/* unplugin-vue-components disabled */import { render } from "./compXinjiang.vue?vue&type=template&id=22c83608&scoped=true"
import script from "./compXinjiang.vue?vue&type=script&lang=js"
export * from "./compXinjiang.vue?vue&type=script&lang=js"

import "./compXinjiang.vue?vue&type=style&index=0&id=22c83608&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c83608"]])

export default __exports__